// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"682":"css/admin-app.6661","4396":"css/app.6661"}[chunkId] + ".css";
};